
import './App.css';
import Routers from './routers/Routers';
import { ToastContainer } from 'react-toastify';
import GlobalExportLoader from './Components/Loader/ExportLoader/GlobalExportLoader';  //FOR EXPORTING LOADER HANDLED GLOBALLY

function App() {
  return (
    <>
      <Routers />
      <ToastContainer />
      <GlobalExportLoader />
    </>
  );
}

export default App;
